import { render, staticRenderFns } from "./HCP_list_approve.vue?vue&type=template&id=36f64af2&scoped=true"
import script from "./HCP_list_approve.vue?vue&type=script&lang=js"
export * from "./HCP_list_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f64af2",
  null
  
)

export default component.exports